import filterRowsWithDifference from './filterRowsWithDifference';

const highlightRowsWithDifference = (table) => {
  if (!table) throw Error('No table found');

  const tbody = table.querySelector('tbody');
  const rows = [...tbody.rows];
  const rowsWithDifference = filterRowsWithDifference(table);

  rows.forEach((row) => row.classList.remove('has_difference'));
  rowsWithDifference.forEach((row) => row.classList.add('has_difference'));
};

export default highlightRowsWithDifference;
